//======> Import Tornado UI Helpers <=======//
import Tornado from './Tornado';

/**======> Referance By Comment <======
 * ===> 01 - Tornado Forms Assets
 * ===> 02 - Controls Placeholder
 * ===> 03 - File Uploader
 * ===> 04 - Progress Bars
 * ===> 05 - Realtime Validate
 * ===> 06 - on Submit Validate
 * ===> 07 - Advanced Select
*/

/*==== Tornado Forms Assets ====*/
export const tornadoForms = options => {
    //=====> Controls Placeholder <=====//
    Tornado.getElements('[placeholder]').forEach(placeholder => {
        var currentPlaceholder = placeholder.getAttribute('placeholder');
        //====> When Focus In Empty Placeholder <===//
        placeholder.addEventListener('focus', event => placeholder.setAttribute('placeholder', ''));
        //====> When Focus Out Restore Placeholder <===//
        placeholder.addEventListener('blur', event => placeholder.setAttribute('placeholder', currentPlaceholder));
    });

    //=====> File Uploader <=====//
    Tornado.getElements('.file-input input[type="file"]').forEach(fileUploader => {
        //====> When Value Change <===//
        fileUploader.addEventListener('change', event => {
            //===> Get Files Names <===//
            var filePath = [];
            for (var i = 0; i < fileUploader.files.length; ++i) filePath.push(fileUploader.files[i].name);
            //===> Set Files Names <===//
            fileUploader.parentNode.setAttribute('data-text',filePath);
        });
    });

    //=====> Progress Bars <=====//
    Tornado.getElements('.progress-bar').forEach(progressBar => {
        var progressValue = progressBar.getAttribute('data-value');
        //===> If Page Direction is Left to Right <===//
        if ( Tornado.direction('page') === 'ltr' ) {
            progressBar.style.backgroundSize = progressValue;
            progressBar.innerHTML = '<span class="progress-num" style="left:' + progressValue + '">' + progressValue + '</span>';
        //===> If Page Direction is Right to Left <===//
        } else if (Tornado.direction('page') === 'rtl') {
            progressBar.style.backgroundSize = progressValue;
            progressBar.innerHTML = '<span class="progress-num" style="right:' + progressValue + '">' + progressValue + '</span>';
        };
    });

    //======> Realtime Validate <======//
    Tornado.getElements('.required,[aria-required="true"],[required]').forEach(element => {
        element.addEventListener('blur', event => Tornado.validate(event.target));
    });

    //======> on Submit Validate <======//
    Tornado.getElements('form:not(.no-vali),.wp7').forEach(element => {
        element.addEventListener('submit', event => {
            //======> Define Data for Success Redirect <======//
            var checkForRedierct = element.getAttribute('data-success') || event.target.querySelector('[name="success-redirect"]');
            if (checkForRedierct) var formData = new FormData();

            //======> Validate The Form Controls <======//
            event.target.querySelectorAll('.required,[aria-required="true"],[required]').forEach(element => {
                //==== if it is label return nothing ====//
                if (element.matches('label' || '.success')) return;
                //======> Validate The Control <======//
                Tornado.validate(element);
                //======> Colect Data for Redirect if Exist <======//
                if (checkForRedierct) {
                    if(element.matches('[type="file"]')) {
                        formData.append(element.getAttribute('name'), element.files[0]);
                    } else {
                        formData.append(element.getAttribute('name'), element.value);
                    }
                }
            });

            //======> if has Error Prevent Submit <======//
            if (event.target.matches('.hasErrors')) return event.preventDefault();

            //======> Success Redirect if Exist <======//
            if (checkForRedierct) {
                var theUrl = element.getAttribute('data-success') || event.target.querySelector('[name="success-redirect"]').value,
                    theAction = element.getAttribute('action'),
                    theMethod = element.getAttribute('method');
                //======> Send Data <======//
                fetch(theAction, {method: theMethod,body: formData})
                //======> Send Data Error Handler <======//
                .then(response => response.json()).catch(error => console.error('Error:', error))
                //======> Send Data Success Redirect <======//
                .then(response => window.location.href = theUrl);
            }
        });
    });

    //======> Advanced Select <======//
    Tornado.advancedSelect('.form-ui select,select.form-control');
}

document.addEventListener('DOMContentLoaded', tornadoForms);